import { FAQPage } from "@kursk/components/pages/FAQPage/FAQPage";
import { reduxWrapper } from "@common/redux/store";
import { loadFAQ } from "@common/redux/slices/faq.slice";

export default function page() {
  return <FAQPage />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store }) => {
  await store.dispatch<any>(loadFAQ({}));
  return { props: {} };
});
